module.exports = __webpack_public_path__ + "media/icons/tapicerka-welurowa-unactive@2x-2a6d73fe.png";